import { Table } from '@burna/monster-design-system';
import cyberno from 'assets/cyberno.png';
import styles from './index.module.scss';

function ScanResults({ data, totalScanners, finishedScans, outOfTime }) {
  if (!data) {
    return null;
  }

  return (
    <div className={styles.table}>
      <Table
        header={{
          title: 'Scan Results',
          badgeLabel: `${finishedScans} of ${totalScanners}`,
          badgeIcon:
            outOfTime || finishedScans === totalScanners
              ? 'check'
              : 'loader:spin'
        }}
        footer={{ label: 'Powered By', iconUrl: cyberno }}
        columnDefinitions={[
          { type: 'lead' },
          {
            type: 'text-featured-icon',
            iconType: 'error',
            theme: 'light-circle-outlined',
            icon: 'virus'
          },
          { type: 'badge', size: 'lg', align: 'end' }
        ]}>
        {data.map((item, i) => (
          <Table.Row key={i}>
            <Table.Cell
              label={item.avName}
              iconUrl={
                !['avast', 'windowsdefender'].includes(item.avName)
                  ? `/scanner/applications/${item.avName}.png`
                  : '/scanner/applications/unknown.png'
              }
            />
            {outOfTime && item.progress === 'loading' ? (
              <>
                <Table.Cell
                  type="warning"
                  icon="alert-triangle"
                  label="Time out"
                />
                <Table.Cell type="error" icon="alert-circle" label="Error" />
              </>
            ) : (
              <>
                {item.malwareState === 'malware' ? (
                  <Table.Cell label={item.malwareName} />
                ) : (
                  <Table.Cell empty />
                )}
                <Table.Cell
                  type={
                    item.malwareState === 'unknown'
                      ? 'warning'
                      : item.malwareState === 'clean'
                      ? 'success'
                      : 'error'
                  }
                  icon={
                    item.malwareState === 'unknown'
                      ? 'loader:spin'
                      : item.malwareState === 'clean'
                      ? 'check'
                      : 'x'
                  }
                  label={
                    item.malwareState === 'unknown'
                      ? 'Checking'
                      : item.malwareState === 'clean'
                      ? 'Scanned'
                      : 'Failed'
                  }
                />
              </>
            )}
          </Table.Row>
        ))}
      </Table>
    </div>
  );
}

export default ScanResults;
